import { createAction } from "redux-actions";
import { START } from "../common";

export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const SET_USER_SETTINGS = "SET_USER_SETTINGS";

export const fetchUserSettings = createAction(GET_USER_SETTINGS + START);
export const updateUserSettings = createAction(SET_USER_SETTINGS + START);
